@if (data) {
  <iu-grid-tab-infinity-scroll-ui
    (columnStateChanged)="onColumnStateChanged($event)"
    (multiSelectEmitter)="onRowSelectedOnGridTab($event)"
    [container]="container"
    [data]="data"
    [DOMParentComponent]="DOMParentComponent"
    [gridPaginator]="gridPaginator"
    [gridTabFilter]="gridTabFilter"
    [isTabTopLevel]="isTabTopLevel"
    [overridedTableHeight]="true"
    [tabId]="tabId"
    [tableHeight]="'100%'"
    [initGridParams]="initGridParams"
    class="gridWidgetContent" />
} @else if (isLoading) {
  <div class="ghost-elt widget-ghost">
    <div class="ghost-rect widget-ghost-rect"></div>
  </div>
} @else if (loadError) {
  <iu-widget-state state="error" (retry)="retryLoad()" />
} @else {
  <iu-widget-state state="noData" />
}
